/* eslint-disable max-len */
import { SUBITEM_REQUIRED, PURCHASE_TYPE_ITEM, SELECTION_MODE_MULTIPLE } from '_utils/constant'

// Ported 1:1 from src/pages/Event/EventDetail/index.js so pricing/quantity
// behaviour stays identical between the old and new UI.
export const formatPrice = (number) => (Math.round(number * 100) / 100).toFixed(2)

export const convertProducts = (productsDetail, listOrderByRef) =>
  productsDetail.map((p) => {
    const quantity =
      listOrderByRef && listOrderByRef.length
        ? listOrderByRef
          .filter((pref) => pref.pid === p.id)
          .reduce((pre, cur) => pre + cur.pQuantity, 0)
        : p.defaultQuantity
    return {
      id: p.id,
      subItems: p.subItems
        ? p.subItems
          .filter((s) => s.required === SUBITEM_REQUIRED && !s.trackInventory && s.selectionMode !== SELECTION_MODE_MULTIPLE)
          .map((s) => ({
            type: s.type,
            name: s.list[0].name,
            price: s.list[0].price,
            required: s.required,
          }))
        : [],
      quantity,
      quantityInput: quantity,
      price: p.price,
      limitPerOrder: p.limitPerOrder,
      minOrderQty: p.minOrderQty,
      index: 1,
      ...(p.splitCasePurchase ? { splitCasePurchase: { ...p.splitCasePurchase } } : {}),
    }
  })

// Same branching as EventDetail#convertProductsWhenEdit, but returns the
// derived collections instead of calling setState directly so it can be
// reused from a hook (and unit tested on its own).
export const convertProductsWhenEdit = (productsDetail, listOrderByRef) => {
  let newProductsDetail = []
  let newOrderProductsReturn = []
  let newProductsDetailIndividual = []
  let newOrderProductsIndividualReturn = []

  productsDetail.forEach((p) => {
    const itemOrderByPid =
      listOrderByRef && listOrderByRef.length
        ? listOrderByRef?.filter((pref) => pref.pid === p.id)
        : []
    if (itemOrderByPid && !!itemOrderByPid.length > 0) {
      let caseIndex = 1
      let individualIndex = 0
      itemOrderByPid.forEach((item) => {
        if (item.pPurchaseType !== PURCHASE_TYPE_ITEM) {
          newProductsDetail = [
            ...newProductsDetail,
            { ...p, index: caseIndex, newOrderCount: p.orderCount },
          ]
          newOrderProductsReturn = [
            ...newOrderProductsReturn,
            {
              id: p.id,
              subItems:
                item && item.pSubItems && !!item.pSubItems.length > 0
                  ? item.pSubItems.map((s) => ({
                      ...s,
                      quantity: s.quantity !== undefined ? s.quantity : (s.qty !== undefined ? s.qty : 1),
                      qty: s.qty !== undefined ? s.qty : (s.quantity !== undefined ? s.quantity : 1),
                    }))
                  : [],
              quantity: item.pQuantity,
              quantityInput: item.pQuantity,
              price: p.price,
              purchaseType: item.pPurchaseType,
              limitPerOrder: p.limitPerOrder,
              index: caseIndex,
            },
          ]
          caseIndex += 1
          individualIndex += 1
        } else {
          if (individualIndex === 0) individualIndex += 1
          newProductsDetailIndividual = [
            ...newProductsDetailIndividual,
            { ...p, index: individualIndex, newOrderCount: p?.splitCasePurchase?.orderCount },
          ]
          newOrderProductsIndividualReturn = [
            ...newOrderProductsIndividualReturn,
            {
              id: p.id,
              subItems: [],
              quantity: item.pQuantity,
              quantityInput: item.pQuantity,
              price: p.splitCasePurchase.costPerItem,
              purchaseType: item.pPurchaseType,
              limitPerOrder: p.limitPerOrder,
              index: individualIndex,
            },
          ]
        }
      })
    } else {
      newProductsDetail = [
        ...newProductsDetail,
        { ...p, index: 1, newOrderCount: p.defaultQuantity + p.orderCount },
      ]
      newOrderProductsReturn = [
        ...newOrderProductsReturn,
        {
          id: p.id,
          subItems: p.subItems
            ? p.subItems
              .filter((s) => s.required === SUBITEM_REQUIRED && !s.trackInventory && s.selectionMode !== SELECTION_MODE_MULTIPLE)
              .map((s) => ({
                type: s.type,
                name: s.list[0].name,
                price: s.list[0].price,
                required: s.required,
              }))
            : [],
          quantity: p.defaultQuantity,
          quantityInput: p.defaultQuantity,
          price: p.price,
          limitPerOrder: p.limitPerOrder,
          minOrderQty: p.minOrderQty,
          index: 1,
          ...(p.splitCasePurchase ? { splitCasePurchase: { ...p.splitCasePurchase } } : {}),
        },
      ]
    }
  })

  const newQuantities = {}
  newOrderProductsIndividualReturn.forEach((item) => {
    newQuantities[`${item.id}-${item.index}-split`] = item.quantity
  })

  return {
    productOrderRender: newProductsDetail,
    productOrderRenderIndividual: newProductsDetailIndividual,
    newOrderProducts: newOrderProductsReturn,
    newOrderProductsIndividual: newOrderProductsIndividualReturn,
    quantities: newQuantities,
    initTotalOrderCount: newOrderProductsReturn.reduce((a, b) => a + b.quantity, 0),
  }
}

export const createAddressString = (address) => {
  if (!address) return null

  const street = address.address?.street || address.address || ''
  const country = address.country || 'Singapore'
  const postalCode = address.postalCode || ''

  return `${street}, ${country}, ${postalCode}`
}

export const findMatchingAddress = (bookingAddress, addresses) => {
  if (!bookingAddress || !addresses || addresses.length === 0) {
    return null
  }

  const normalizedBookingAddress = bookingAddress.toLowerCase().replace(/\s+/g, ' ').trim()

  return addresses.find((addr) => {
    const addressString = createAddressString(addr)
    if (!addressString) return false

    const normalizedAddressString = addressString.toLowerCase().replace(/\s+/g, ' ').trim()
    return normalizedAddressString === normalizedBookingAddress
  })
}
